/**
 * This is the registration service.
 * @memberOf registration Module
 * @namespace registration Service
 */

/**
 * @name registrationService
 * @desc Create the service.
 * @param $q
 * @param registrationDataService
 * @memberOf registration Module registration Service
 * @ngInject
 */
function registrationFactory($q, registrationDataService) {
    // Create the service.
    var service = {};
    return service;

}

export default registrationFactory;



// WEBPACK FOOTER //
// ./src/login/registration/registration.service.js